import { DepartmentOutline, PersonOutline } from '@lyearn/icons';
import { Avatar, Stack, Typography } from '@lyearn/ui';
import { logoStyle } from '@/modules/knowledge-asset/KnowledgeAssetManager/styles';

interface PersonaCardProps {
  avatarUrl: string;
  title: string;
  role: string;
  departments: string[];
}

export const PersonaCard = ({ avatarUrl, title, role, departments }: PersonaCardProps) => {
  return (
    <Stack alignItems="end" className="border border-border rounded-12 w-full p-24" gapX={20}>
      <Stack>
        <Avatar className={logoStyle} size={100} src={avatarUrl} />
      </Stack>
      <Stack direction="col" gapY={10}>
        <Typography variant="heading-m">{title}</Typography>
        <Stack gapX={8}>
          <PersonOutline fillColorToken="icon-secondary" height={20} width={20} />
          <Typography className="text-text-secondary" variant="body-short-02">
            {role}
          </Typography>
        </Stack>
        <Stack gapX={8}>
          <DepartmentOutline fillColorToken="icon-secondary" height={20} width={20} />
          <Typography className="text-text-secondary" variant="body-short-02">
            {departments.join(' , ')}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
